// extracted by css-extract-rspack-plugin
export default {"card":"d6pyHn","logo":"kdsxiP","grayscale":"lDAIif"};